import { clamp } from '../sim/math.ts';

export type PinchPoint = { x: number; y: number };

/** A second finger that lands on the first would make the scale explode. */
export const PINCH_MIN_SPAN_PX = 16;

export function pinchSpan(a: PinchPoint, b: PinchPoint): number {
  return Math.hypot(b.x - a.x, b.y - a.y);
}

export function pinchCenter(a: PinchPoint, b: PinchPoint): PinchPoint {
  return { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 };
}

/**
 * Scales `startZoom` by the current finger span over the span when the pinch began.
 * Fingers spreading zooms in (higher number); pinching together zooms out.
 */
export function pinchZoom(
  startZoom: number,
  startSpan: number,
  currentSpan: number,
  minZoom: number,
  maxZoom: number,
): number {
  if (!(startSpan > 0) || !(currentSpan > 0)) {
    return startZoom;
  }

  return clamp(startZoom * (currentSpan / startSpan), minZoom, maxZoom);
}

export function pinchPair<T extends { isDown: boolean }>(
  pointers: readonly T[],
): [T, T] | null {
  const down = pointers.filter((pointer) => pointer.isDown);

  return down.length >= 2 ? [down[0]!, down[1]!] : null;
}
